module.exports = __webpack_public_path__ + "img/owner-aziende-emt.ba11cb5d.png";